/**
 * useDocumentTitle — keeps <title>, meta description, and robots in sync with
 * the current route (and optional page-level overrides).
 *
 * On macOS the document title is the window title: it labels the installed
 * Dock app's titlebar, its entry in Mission Control, the Window menu, and
 * the ⌘-Tab/window switcher. A static title makes every window look
 * identical there — native apps name the screen you're on.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import {
  applyPageMeta,
  documentTitleFor,
  mergePageMeta,
  resolvePageMeta,
  usePageMetaOverride,
} from '../app/pageMeta';

export function useDocumentTitle(unread = 0): void {
  const { pathname, search } = useLocation();
  const override = usePageMetaOverride();

  useEffect(() => {
    const meta = mergePageMeta(resolvePageMeta(pathname, search), override);
    const title = documentTitleFor(pathname, unread, search, override);
    applyPageMeta(meta, title);
  }, [pathname, search, unread, override]);
}
